import { render, staticRenderFns } from "./FieldGroup.vue?vue&type=template&id=23546bd9&scoped=true"
import script from "./FieldGroup.vue?vue&type=script&lang=ts"
export * from "./FieldGroup.vue?vue&type=script&lang=ts"
import style0 from "./FieldGroup.vue?vue&type=style&index=0&id=23546bd9&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23546bd9",
  null
  
)

export default component.exports